/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} role Role of user
 */
import { Role } from "@/store/auth/enum/AuthEnums";
import moment from "moment";

/**
 * @description
 *
 * this function use for convert number to compact string format
 * such as
 *
 * 10,000 return 10K
 * 1,000,000 return 1M
 *
 * @param value
 */
export const convertToCompactNumber = (value: number): string => {
  const formatter = Intl.NumberFormat("en", { notation: "compact" });

  return formatter.format(value);
};

/**
 * @description
 *
 * this function use for convert number to string format
 * such as
 *
 * 10000 return 10,000
 * 1000000 return 1,000,000
 *
 * @param value
 */
export const convertToFormatNumber = (value: number): string => {
  const formatter = Intl.NumberFormat("en");

  return formatter.format(value);
};

export const getHomeRouteForLoggedInUser = (role: Role) => {
  return { name: `${role}-dashboard` };
};

/**
 * @description Format Date
 * @param {string} date String of date to format
 * @param {string} format Format default is "DD MMM YYYY, HH:MM"
 * @param {string} locale Locale default is "th"
 * @return {string} - Formatted date
 */
export const formatDate = (
  date: string | Date,
  format = "DD MMM YYYY, HH:MM",
  locale = "th"
) => {
  return moment(Number(date)).locale(locale).format(format);
};

export const formatNumber = (value: string | number) => {
  if (isNaN(Number(value))) {
    return "";
  }
  return new Intl.NumberFormat().format(Number(value));
};

/**
 * @description Check value is number or not
 * @param {any} n - Value to check
 * @return {number} - Number value or 0
 */
export const numOr0 = (n: any): number => {
  if (n === null || n === "") {
    return 0;
  }
  return isNaN(n) ? 0 : parseInt(n);
};

/**
 * @description Summary value of object in array
 * @param {Array} arr - Array to summary
 * @param {string} filedName - Field name to summary
 * @return {number} - Summary value
 */
export const sumValueInArray = (
  arr: Array<any> | undefined,
  filedName: string
): number => {
  if (arr && arr.length > 0) {
    return arr
      .map((element) => {
        //get array of vdoLength
        return element[filedName];
      })
      .reduce((a, b) => numOr0(a) + numOr0(b)); //sum vdo length per unit
  } else {
    return 0;
  }
};

export const validateImage = async (e) => {
  return new Promise((resolve) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = async (evt) => {
        const img = new Image();

        img.onload = async () => {
          return resolve(file);
        };

        img.src = String(evt.target?.result);
      };
    } else {
      return resolve(null);
    }
  });
};

export const validateFile = async (e) => {
  return new Promise((resolve) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = async (evt) => {
        const img = new Image();

        img.onload = async () => {
          return resolve(file);
        };

        img.src = String(evt.target?.result);
      };
    } else {
      return resolve(null);
    }
  });
};

export const validateVideo = async (e, videoRef, fileUpload = null) => {
  return new Promise((resolve) => {
    if (fileUpload || (e.target.files && e.target.files.length > 0)) {
      const file = fileUpload ? fileUpload : e.target.files[0];
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.addEventListener("load", function () {
        videoRef.src = reader.result;
      });
      resolve(file);
    } else {
      return resolve(null);
    }
  });
};
